export default __webpack_public_path__ + "8af13b9c.png";